import React from 'react';
import ReactDOM from 'react-dom';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Hits, Configure, ScrollTo } from 'react-instantsearch-dom';

import { GetAlgoliaIndex } from '3-components/Utils/AlgoliaUtils';
import AlgoliaPagination from '3-components/AlgoliaPagination/AlgoliaPagination';
import CustomMenuFilter from '4-sections/AlgoliaSearch/widgets/CustomMenuFilter';
import ArticleCard from '3-components/ArticleCard/ArticleCard';
import NoResults from './widgets/NoResults';
import CustomStats from './widgets/CustomStats';

const APP_CLASS = 'blog-listing-app';
const ALGOLIA_APP_ID = '1K2NLKV3ZJ';
const ALGOLIA_API_ID = '7a32b5b2e4b7dcec55dcb2efc053fedd';
const ALGOLIA_INDEX = 'BLOG';

// NOTE: This is the demo Algolia searchClient. Update to your projects ID
const searchClient = algoliasearch(
    ALGOLIA_APP_ID,
    ALGOLIA_API_ID
);

// populate with search term from query string
// show number of results
// show filtering
// show results
// show pagination
// show no results found message

interface BlogListingProps {
    selectedFacetItem?: string;
}

const BlogListing = ({ selectedFacetItem }: BlogListingProps) => {
    // const { selectedFacetItem } = props;
    const indexToUse = GetAlgoliaIndex(ALGOLIA_INDEX);
    // console.log(selectedFacetItem);
    return (
        <InstantSearch
            indexName={indexToUse}
            searchClient={searchClient}
        >
            <Configure
                hitsPerPage={12}
            />

            <ScrollTo>
                <div className="blog-listing-filters">
                    <CustomMenuFilter
                        seeAllText="All posts"
                        filterAttribute="category"
                        responsiveBreakpoint={1280}
                        selectedAttribute={selectedFacetItem}
                    />
                </div>

                <CustomStats />

                <div className="blog-listing-results">
                    <Hits hitComponent={ArticleCard} />

                    <NoResults />

                    <AlgoliaPagination />
                </div>
            </ScrollTo>

        </InstantSearch>
    );
};

const el = document.getElementById(`${APP_CLASS}`);
const elProps = el?.dataset.props || '{}';
const propsObj = JSON.parse(elProps);

if (el) {
    ReactDOM.render(
        <BlogListing {...propsObj} />,
        el
    );
}
